// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reoc-order-report table>thead>tr>th{position:sticky!important;position:-webkit-sticky!important;top:0;z-index:1}.reoc-order-report table>thead>tr>th:first-child{z-index:3}.reoc-order-report table>tbody>tr>td:first-child,.reoc-order-report table>tbody>tr>th:first-child,.reoc-order-report table>thead>tr>th:first-child{position:sticky!important;position:-webkit-sticky!important;left:0}.reoc-order-report .v-data-table>.v-data-table__wrapper>table>tbody>tr:hover{cursor:pointer}", ""]);
// Exports
module.exports = exports;
